import {brandConfigMap} from "@/brand";
import store from "@/store";
import {getBrandConfig} from "@/brand";

export function setNewBrandConfigLanguage(brand) {
    let base_url = window.location.origin
    if (brand === "ethiotel-et-amh") brandConfigMap.set(base_url, getBrandConfig('ethiotel-et-en'));
    if (brand === "ethiotel-et-en") brandConfigMap.set(base_url, getBrandConfig('ethiotel-et-amh'));
    if (brand === "dtac-tai-tha") brandConfigMap.set(base_url, getBrandConfig('dtac-tai-en'));
    if (brand === "dtac-tai-en") brandConfigMap.set(base_url, getBrandConfig('dtac-tai-tha'));
    setBrandConfig()
}

export function setBrandConfig() {
    const domain = window.origin;
    let brandConfig = brandConfigMap.get(domain);
    if (!brandConfig) {
        const h = window.location.hostname;
        if (h === 'localhost' || h === '127.0.0.1') {
            const port = window.location.port || '';
            if (port === '8081') brandConfig = getBrandConfig('mtn-nga-en');
            else brandConfig = getBrandConfig('saf-ke-en');
        }
    }
    if (!brandConfig) brandConfig = brandConfigMap.get('default');
    store.commit('setBrandConfig', brandConfig);

    const brandStyles = require(`../brand/${brandConfig.brand}/styles/index.js`).styles;
    const brandStyleSheet = document.createElement('style');

    let brandStyleInnerHTML = '';

    brandStyles.backgrounds.forEach((background) => {
        if (brandStyleInnerHTML === '') brandStyleInnerHTML += `.${background.className} { background-color: ${background.colour} }`;
        else brandStyleInnerHTML += ` .${background.className} { background-color: ${background.colour} }`;
    });

    brandStyles.text.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { color: ${textItem.colour} }`;
    });

    brandStyles.borders.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { border-color: ${textItem.colour} }`;
    });

    // Add RTL (Right to left) styles if they exist
    if (brandStyles.rtl) {
        brandStyles.rtl.forEach((rtlItem) => {
            brandStyleInnerHTML += ` .${rtlItem.className} { ${rtlItem.css} }`;
        });
        
        // Apply global RTL (Right to left) styles for demo-arabic brand
        if (brandConfig.brand === 'demo-arabic') {
            brandStyleInnerHTML += ` body { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .content-body-default, .content-body-noHeader { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .d-flex { direction: rtl; }`;
            brandStyleInnerHTML += ` .row { direction: rtl; }`;
            brandStyleInnerHTML += ` .col, .col-10, .col-12, .col-sm-8, .col-sm-9, .col-md-6, .col-md-7, .col-lg-5, .col-lg-6, .col-xl-3, .col-xl-4 { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` input, textarea, select { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` button { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` .btn { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` .navbar { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .nav { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .nav-item { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .dropdown-menu { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .modal-content { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .card { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .list-group { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .list-group-item { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .form-control { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` .form-label { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` .alert { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .badge { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .table { direction: rtl; text-align: right; }`;
            brandStyleInnerHTML += ` .table th, .table td { text-align: right; direction: rtl; }`;
            brandStyleInnerHTML += ` .justify-content-start { justify-content: flex-end !important; }`;
            brandStyleInnerHTML += ` .justify-content-end { justify-content: flex-start !important; }`;
            brandStyleInnerHTML += ` .text-start { text-align: right !important; }`;
            brandStyleInnerHTML += ` .text-end { text-align: left !important; }`;
            brandStyleInnerHTML += ` .float-start { float: right !important; }`;
            brandStyleInnerHTML += ` .float-end { float: left !important; }`;
            brandStyleInnerHTML += ` .ms-auto { margin-left: 0 !important; margin-right: auto !important; }`;
            brandStyleInnerHTML += ` .me-auto { margin-right: 0 !important; margin-left: auto !important; }`;
            brandStyleInnerHTML += ` .ps-0, .ps-1, .ps-2, .ps-3, .ps-4, .ps-5 { padding-left: 0 !important; }`;
            brandStyleInnerHTML += ` .pe-0, .pe-1, .pe-2, .pe-3, .pe-4, .pe-5 { padding-right: 0 !important; }`;
            brandStyleInnerHTML += ` .ms-0, .ms-1, .ms-2, .ms-3, .ms-4, .ms-5 { margin-left: 0 !important; }`;
            brandStyleInnerHTML += ` .me-0, .me-1, .me-2, .me-3, .me-4, .me-5 { margin-right: 0 !important; }`;
        }
    }

    brandStyleSheet.innerHTML = brandStyleInnerHTML;
    document.body.appendChild(brandStyleSheet);
}
